import React, { useState } from 'react';
import { FormGroup, Row } from 'reactstrap';
import Rating from 'react-rating';
import { Translate, withLocalize } from 'react-localize-redux';

import PropTypes from 'prop-types';
import RatingIcon from './RatingIcon';


const ratings = {
  1: <Translate id="ratings.terrible" />,
  2: <Translate id="ratings.poor" />,
  3: <Translate id="ratings.average" />,
  4: <Translate id="ratings.verygood" />,
  5: 'Excellent',
};

function ratingInWords(rating) {
  return ratings[rating];
}

function RatingWidget(props) {
  const [starRating, setRating] = useState(0);

  const {
    isSubmitted,
    name,
    rating,
    size,
    title,
    validate,
  } = props;

  const starSize = size === 'small' ? '30px' : '40px';

  return (
    <div>
      {size === 'small'
        && <p className="reg-text" style={{ 'margin-bottom': '0' }}>{title}</p>}
      {size === 'large'
        && (
        <p className="title" style={{ 'margin-bottom': '0' }}>
          {title}
        </p>
        )}

      <Row form className="align-items-center h-100">
        <FormGroup>
          <div className="text-left">
            <Rating
              initialRating={rating}
              emptySymbol={<RatingIcon size={starSize} />}
              fullSymbol={<RatingIcon full size={starSize} />}
              onClick={(rate) => props.handleChange(rate, name)}
              onHover={(value) => { setRating(value); }}
            />
          </div>
          {(!validate() && isSubmitted) && <p><Translate id="required" /></p>}
        </FormGroup>
        {size === 'large' && <h5 style={{ marginLeft: '10px' }}>{ratingInWords(starRating)}</h5>}

      </Row>

    </div>
  );
}


RatingWidget.propTypes = {
  isSubmitted: PropTypes.bool,
  name: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  validate: PropTypes.func,
  title: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
};

export default withLocalize(RatingWidget);
